import React from "react";
import "./App.css";
import i18next from "./i18n";
import logo from "./images/1_1_logo_XPER_blue_woBg 1.svg";
import { showPreferences } from "vanilla-cookieconsent";
function Footer() {
  return (
    <footer className="container max-w-xl bg-white text-main-dark py-16 flex flex-col px-4 items-start">
      <div className=" w-full flex flex-row flex-wrap md:flex-nowrap gap-10 ">
        <div className="w-full md:w-1/2 flex flex-col text-left justify-between">
          <p>{i18next.t("footer.description")}</p>
          <p className="mb-0 md:mb-16">
            {i18next.t("footer.contact.title")}{" "}
            <a className="hover:underline text-contrast-ink" href="tel:+4798228453">
              {i18next.t("footer.contact.phone")}
            </a>
            <br />
            {i18next.t("footer.contact.email.prefix")}{" "}
            <a
              className="hover:underline text-contrast-ink"
              href="mailto:post@xperconsulting.no"
            >
              {i18next.t("footer.contact.email.address")}
            </a>
            <br />
            {i18next.t("footer.contact.address.prefix")}{" "}
            <a
              className="hover:underline text-contrast-ink"
              href="https://maps.app.goo.gl/8rSZyfMyvtKTuqDB9"
              target="_blank"
            >
              {i18next.t("footer.contact.address.text")}
            </a>
            <br />

            <a 
              className="hover:underline text-contrast-ink"
              href="#" onClick={showPreferences}>
              {i18next.t("footer.contact.cookie.title")}
            </a>
          </p>
        </div>

        <div className="w-full md:w-1/2 flex flex-row gap-10">
          <div className="w-1/2 flex flex-col gap-2 text-left">
            <h2 className="font-bold text-lg">{i18next.t("footer.links.title")}</h2>
            <a className="hover:underline" href="/">
              {i18next.t("footer.links.home")}
            </a>
            <a className="hover:underline" href="/ccm">
              {i18next.t("footer.links.ccm")}
            </a>
            <a className="hover:underline" href="/docengine">
              {i18next.t("footer.links.docengine")}
            </a>
            <a className="hover:underline" href="/migrator">
              {i18next.t("footer.links.migrator")}
            </a>
            <a className="hover:underline" href="/kunder">
              {i18next.t("footer.links.customers")}
            </a>
            <a className="hover:underline" href="/partnere">
              {i18next.t("footer.links.partners")}
            </a>
          </div>
          <div className="w-1/2 flex flex-col gap-2 text-left">
            <h2 className="font-bold text-lg">{i18next.t("footer.about.title")}</h2>
            <a className="hover:underline" href="/om-xper">
              {i18next.t("footer.about.about")}
            </a>
            <a className="hover:underline" href="/skjema/kontakt-oss">
              {i18next.t("footer.about.contact")}
            </a>
            <a
              className="hover:underline"
              href="https://www.linkedin.com/company/xper-consulting/"
              target="_blank"
            >
              {i18next.t("footer.about.linkedin")}
            </a>
          </div>
        </div>
      </div>
      <div className="w-full md:w-1/2 flex flex-row items-start gap-10 justify-start mt-12 md:-mt-12 ">
        <div className="flex flex-row  md:flex-nowrap w-full gap-6 text-left mt-auto items-center">
          <img src={logo} alt="XPER Consulting" className="w-40" />
          <div className="flex flex-row flex-wrap">
            {i18next.t("footer.copyright.text")}&nbsp;
            <span>{i18next.t("footer.copyright.orgNumber")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
